import React from 'react';
import './Header.css';

const Header = () => {
    return (
        <div className="project-header">
            <div id='header__background-img'/>
            
            <div className='header__content'>
                <h1 id='header__title'>Projects</h1>
            </div>
        </div>
    );
};

export default Header;